export default {
  SET_DONATIONS(state, donations) {
    state.donationsState = 'ready'
    state.donations = donations
  },
  RESET_DONATIONS(state) {
    state.donationsState = null
    state.donations = []
  },
  LOADING_DONATIONS(state) {
    state.donationsState = 'loading'
  },
  EDIT_DONATION(state, payload) {
    const item = state.donations.find(item => item.id === payload.id);
    Object.assign(item, payload);
  },
  REMOVE_DONATION: (state, donationId) => {
    const i = state.donations.map(item => item.id).indexOf(donationId);
    state.donations.splice(i, 1);
  }
}
